// Generated file - do not change manually!
/**
 * Different types of Priority.
 */
export var Priority;
(function (Priority) {
    /**
     * High priority.
     */
    Priority["High"] = "High";
    /**
     * Low priority.
     */
    Priority["Low"] = "Low";
    /**
     * Medium priority.
     */
    Priority["Medium"] = "Medium";
    /**
     * Default, none priority.
     */
    Priority["None"] = "None";
})(Priority || (Priority = {}));
